var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10002_5224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4.90158C14 7.40158 10.8438 9.40158 7 9.40158C3.125 9.40158 0 7.40158 0 4.90158C0 2.43283 3.125 0.401581 7 0.401581C10.8438 0.401581 14 2.43283 14 4.90158ZM7 1.40158C6.71875 1.40158 6.5 1.65158 6.5 1.90158V2.65158C6.5 2.93283 6.71875 3.15158 7 3.15158C7.25 3.15158 7.5 2.93283 7.5 2.65158V1.90158C7.5 1.65158 7.25 1.40158 7 1.40158ZM2 4.90158C2 5.18283 2.21875 5.40158 2.5 5.40158H3.5C3.75 5.40158 4 5.18283 4 4.90158C4 4.65158 3.75 4.40158 3.5 4.40158H2.5C2.21875 4.40158 2 4.65158 2 4.90158ZM10 4.90158C10 5.18283 10.2188 5.40158 10.5 5.40158H11.5C11.75 5.40158 12 5.18283 12 4.90158C12 4.65158 11.75 4.40158 11.5 4.40158H10.5C10.2188 4.40158 10 4.65158 10 4.90158ZM7 6.65158C6.71875 6.65158 6.5 6.90158 6.5 7.15158V7.90158C6.5 8.18283 6.71875 8.40158 7 8.40158C7.25 8.40158 7.5 8.18283 7.5 7.90158V7.15158C7.5 6.90158 7.25 6.65158 7 6.65158ZM4.34375 2.30783C4.15625 2.12033 3.8125 2.12033 3.625 2.30783C3.4375 2.49533 3.4375 2.83908 3.625 3.02658L4.125 3.52658C4.3125 3.71408 4.65625 3.71408 4.84375 3.52658C5.03125 3.33908 5.03125 2.99533 4.84375 2.80783L4.34375 2.30783ZM10.3438 2.30783C10.1562 2.12033 9.8125 2.12033 9.625 2.30783L9.125 2.80783C8.9375 2.99533 8.9375 3.33908 9.125 3.52658C9.3125 3.71408 9.65625 3.71408 9.84375 3.52658L10.3438 3.02658C10.5312 2.83908 10.5312 2.49533 10.3438 2.30783ZM4.84375 7.02658C5.03125 6.83908 5.03125 6.49533 4.84375 6.30783C4.65625 6.12033 4.3125 6.12033 4.125 6.30783L3.625 6.80783C3.4375 6.99533 3.4375 7.33908 3.625 7.52658C3.8125 7.71408 4.15625 7.71408 4.34375 7.52658L4.84375 7.02658ZM9.84375 6.30783C9.65625 6.12033 9.3125 6.12033 9.125 6.30783C8.9375 6.49533 8.9375 6.83908 9.125 7.02658L9.625 7.52658C9.8125 7.71408 10.1562 7.71408 10.3438 7.52658C10.5312 7.33908 10.5312 6.99533 10.3438 6.80783L9.84375 6.30783ZM8.75 4.90158C8.75 4.49533 7.9375 4.15158 7 4.15158C6.03125 4.15158 5.25 4.49533 5.25 4.90158C5.25 5.33908 6.03125 5.65158 7 5.65158C7.9375 5.65158 8.75 5.33908 8.75 4.90158ZM7 14.4016C3.1875 14.4016 0.09375 11.4016 0 7.62033C0.40625 8.12033 0.90625 8.55783 1.5 8.93283C2.9375 9.87033 4.875 10.4016 7 10.4016C9.09375 10.4016 11.0312 9.87033 12.4688 8.93283C13.0625 8.55783 13.5625 8.12033 13.9688 7.62033C13.875 11.4016 10.7812 14.4016 7 14.4016Z",
    fill: "black",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10002_5224",
    x: 0,
    y: 0.401581,
    width: 14,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10002_5224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10002_5224",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default ForwardRef;